// libraries
import qs from 'qs';
// services
import AxiosInstanceCreator from 'services/api';

const pmtInstance = new AxiosInstanceCreator().create();

export const pmtApi = {
  /**
   * PMT History 조회
   * @param {userId, page, issueDateFrom, issueDateTo} data
   * @returns
   */
  async getPmtHistoryList(data) {
    return await pmtInstance.get(`/pmt?${qs.stringify(data)}`).then((res) => res.data);
  },

  /**
   * PMT History  조회-벤더용
   * @param {companyId, page, issueDateFrom, issueDateTo} data
   * @returns
   */
  async getPmtHistoryListVendor(data) {
    return await pmtInstance.get(`/pmt/company?${qs.stringify(data)}`).then((res) => res.data);
  },

  /**
   * PMT List 조회
   * @param {ptwId} id
   * @returns
   */
  async getPmtList(id) {
    return await pmtInstance.get(`/pmt/${id}`).then((res) => res.data);
  },

  /**
   * PMT SAVE
   * @param {ptwId, approvalUserId, approvalName, order, badgeNo, signatureFileId, comment, permitNumber, companyId, companyName} data
   * @returns
   */
  async createPmt(data) {
    return await pmtInstance.post(`/pmt`, data).then((res) => res.data);
  }
};
